import {Classes, Labeled} from "./Basics";
import PredefinedTextSetProperty from "./PredefinedTextSetProperty";

type Properties = Classes & Labeled & {
    val: boolean
    onChange: (val: boolean) => void
}

function BooleanProperty(props: Properties) {
    function handleOnChange(val: string) {
        if (props.onChange != null) {
            if (val == "True") {
                props.onChange(true)
            }
            if (val == "False") {
                props.onChange(false)
            }
        }
    }

    return <>
        <PredefinedTextSetProperty
            label={props.label}
            val={props.val ? "True" : "False"}
            options={["True", "False"]}
            onChange={handleOnChange}
            inputAdditionalClassName={props.inputAdditionalClassName}
            labelAdditionalClassName={props.labelAdditionalClassName}
        />
    </>

}

export default BooleanProperty